﻿<template>
    <div>
        <div v-if="loading_calendar" class="tc-cal-loading" role="status" aria-live="polite">
            <p>
                <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                Loading available dates…
            </p>
            <div class="tc-cal-skeleton" aria-hidden="true"><span v-for="n in 35" :key="n"></span></div>
        </div>

        <div class="custom-calendar" :hidden="loading_calendar" >
            <calendar_month :tour_ids="tour_ids" :selected_tour_id="selected_tour_id" :selected_month=selected_month @monthChange="onMonthChange" ref="calendar_month"></calendar_month>
            <calendar_details :trip_index=trip_index :tour_ids="tour_ids" :selected_tour_id="selected_tour_id" @dateChange="onDateChange" ref="calendar_details"></calendar_details>
        </div>
    </div>
</template>

<script lang="ts" src="./calendar.ts"></script>